import { ThirdPartyDraggable } from '@fullcalendar/interaction';
import dragula from 'dragula';

export default {
    mounted() {
        this.$nextTick(() => {
            this.setupDraggable();
        });
    },
    methods: {
        setupDraggable() {
            const dragContainer = this.$refs.dragContainer;

            let hasMultiple = false,
                selectedItems,
                mirrorContainer;

            dragula({
                containers: [dragContainer],
                copy: true,
            }).on('cloned', (clone, original, type) => {
                mirrorContainer = $('.gu-mirror').first();
                mirrorContainer.removeClass('selectedItem');
                selectedItems = $('.selectedItem');
                hasMultiple = selectedItems.length > 0;

                if (hasMultiple) {
                    $('.gu-transit').addClass('selectedItem');
                    selectedItems = $('.selectedItem');
                    mirrorContainer.empty();

                    this.createSelectedItemsMirror(mirrorContainer, original);
                }

                selectedItems = document.querySelectorAll('.selectedItem');
            }).on('drop', () => {
                this.removeGuTransitFromSelectedItems();
            }).on('cancel', (original, container, source) => {
                this.removeGuTransitFromSelectedItems();
            });

            // eslint-disable-next-line no-new
            new ThirdPartyDraggable(dragContainer, {
                itemSelector: '.finder-list-item',
                mirrorSelector: '.gu-mirror',
                eventData(eventEl) {
                    return {
                        title: eventEl.innerText,
                        duration: '02:00',
                        create: true,
                    };
                },
            });
        },

        createSelectedItemsMirror(mirrorContainer, original) {
            const selectedItems = $('.selectedItem');
            const selectedContentsIds = [];

            selectedItems.each(function (index) {
                const item = $(this);
                const mirror = item.clone(true);
                mirror.css('position', 'absolute');
                mirror.css('top', `${index * 2}px`);
                mirror.css('left', `${index * 2}px`);
                mirror.css('z-index', `${100 - (index * 2)}`);
                mirror.css('background-color', 'rgba(255,255,255,1)');
                mirror.css('opacity', 1);

                mirror.removeClass('selectedItem gu-transit');

                mirrorContainer.append(mirror);
                mirrorContainer.css('background-color', 'transparent');
                mirrorContainer.css('opacity', 1);
                mirrorContainer.css('border-color', 'transparent');
                mirrorContainer.css('box-shadow', 'none');
                mirrorContainer.css('position', 'relative');

                if (selectedItems.length > 1) {
                    const numDiv = document.createElement('div');
                    $(numDiv).addClass('finder-list-item__mirror-count');
                    numDiv.innerText = selectedItems.length;

                    mirrorContainer.append(numDiv);
                }


                item.addClass('gu-transit');
                selectedContentsIds.push(item.data('content-id'));
            });

            // eslint-disable-next-line no-param-reassign
            original.dataset.selectedContentsIds = JSON.stringify(selectedContentsIds);
        },

        removeGuTransitFromSelectedItems() {
            const selectedItems = $('.selectedItem');

            selectedItems.each(function (index) {
                const item = $(this);
                item.removeClass('gu-transit');
            });
        },
    },
};
